// extracted by mini-css-extract-plugin
export default {"bind_button":"bind_button--FWtzk"};